import * as React from "react";
import { IconChevronLeft, IconChevronRight } from "../../components/icons.jsx";
import { RewardReadyBadge } from "./RewardReadyBadge.jsx";

// Add an activity with a stable key, title, description, image and onOpen callback.
// Two cards per page keep future activities within the same viewport.
export function EventActivities({ activities }) {
  const [page, setPage] = React.useState(0);
  const pages = Math.max(1, Math.ceil(activities.length / 2));
  const current = Math.min(page, pages - 1);
  const visible = activities.slice(current * 2, current * 2 + 2);
  return <nav className="halloween-menu" aria-label="Активности Хэллоуина">
    <div className="halloween-section-heading"><h3>Приключения</h3>
      {pages > 1 ? <div className="halloween-activity-pages">
        <button type="button" aria-label="Предыдущие активности" disabled={current === 0} onClick={() => setPage(current - 1)}><IconChevronLeft /></button>
        <span>{current + 1} / {pages}</span>
        <button type="button" aria-label="Следующие активности" disabled={current === pages - 1} onClick={() => setPage(current + 1)}><IconChevronRight /></button>
      </div> : <span>Играй и собирай награды</span>}
    </div>
    <div className="halloween-activity-grid">
      {visible.map(activity => <button type="button" key={activity.key} className="halloween-menu-row halloween-flight-card" onClick={activity.onOpen}>
        <span className="halloween-menu-icon halloween-menu-flight"><img src={activity.image} alt="" /></span>
        <span className="halloween-menu-copy"><b>{activity.title}{activity.ready && <RewardReadyBadge label="Доступна награда" />}</b><small>{activity.description}</small><span className="halloween-entry-link">{activity.action || "Открыть"} →</span></span>
      </button>)}
    </div>
  </nav>;
}
